module.exports = __webpack_public_path__ + "static/img/tapapp_logo.eeb6bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tapapp_logo.png
// module id = 6JPQ
// module chunks = 1